import { render, staticRenderFns } from "./SurveyQuestion.vue?vue&type=template&id=ed351ab2"
import script from "./SurveyQuestion.vue?vue&type=script&lang=js"
export * from "./SurveyQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed351ab2')) {
      api.createRecord('ed351ab2', component.options)
    } else {
      api.reload('ed351ab2', component.options)
    }
    module.hot.accept("./SurveyQuestion.vue?vue&type=template&id=ed351ab2", function () {
      api.rerender('ed351ab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/web-components/survey/SurveyQuestion.vue"
export default component.exports